import { Component, OnInit } from '@angular/core';
declare var $: any;
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from 'src/app/services/service.service';

import { User } from './../../models/user.model';
@Component({
  selector: 'app-user-mngnt',
  templateUrl: './user-mngnt.component.html',
  styleUrls: ['./user-mngnt.component.scss']
})
export class UserMngntComponent implements OnInit {

  public searchText = null;
  public size: number = 100;
  public page: number = 1;
  userSaveSuccess: boolean = false;
  savedUser: any = null;

  users: any;
  dataObj = new User();
  selectedUser: any;
  prevPass: string = '';
  isEdituser: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ServiceService,
  ) { }

  ngOnInit() {

    this.getUsers();

  }


  /**
   * Getting user list.
   */
  private getUsers() {
    $(".overlay-loading").show();
    let url = 'get-all-users' + '?size=' + this.size + '&page=' + (this.page - 1) + '&sort-by=billOfLadingId&order-by=asc';
    this.service.getUserList(url).subscribe(data => {
      $(".overlay-loading").hide();
      this.users = data;
      this.sortTenants();
    });
  }


  /**
   * Api call to save user.
   *
   */
  public saveUserDetails(): void {
    $(".overlay-loading").show();
    
    this.service.saveUserDetailsSingle(this.dataObj, this.prevPass).subscribe(res => {
      this.userSaveSuccess = true;
      // this.users = res;
      this.savedUser = res;
      $(".overlay-loading").hide();
    }, error => {
      $(".overlay-loading").hide();
      alert('Error while saving user details'+ error?.error?.message);
      console.log(error);
    });
  }

  /**
   *  Used to set selected user details.
   *
   * @param user
   */
  public selectRecord(user: User): void {
    this.selectedUser = user;
  }

  public setUserObj(): void {
    this.dataObj = new User();
    this.isEdituser = false;
  }

  /**
   * Delete user.
   */
  public deleteUser(): void {
    this.service.deleteUserDetails(this.selectedUser.userId).subscribe(res => {
    });
  }

  /**
   * Edit user
   */
  public editUser(user: User): void {
    this.dataObj = user;
    
    this.prevPass = user.password;
    this.isEdituser = true;
  }


  byId(item1: any, item2: any) {
    return item1 && item2 && item1.tenantId === item2.tenantId;
  }

  byRoleId(item1: any, item2: any) {
    return item1 && item2 && item1.roleId === item2.roleId;
  }

  searchMethod() {
    if (this.searchText) {
      $(".overlay-loading").show();
      this.service.getUserRoleTenantFilter(this.searchText, this.page - 1, this.size).subscribe(res => {
        $(".overlay-loading").hide();
        this.users = res;
        this.sortTenants();
      }, error => {
        $(".overlay-loading").hide();
        console.log(error);
      });
    } else {
      this.getUsers();
    }
  }

  nextBtnClick(incr) {
    this.page = +this.page + incr;
    this.searchMethod();
  }

  sortTenants() {
    if (this.users && this.users.tenants) {
      this.users.tenants.sort((a, b) => 
        a.tenantName.localeCompare(b.tenantName)
      );
    }
  }


}
